export default {
  searchBox: {
    showFilterBtn: 'Hiện filter',
    hideFilterBtn: 'Ẩn filter',
    resetFilterBtn: 'Xóa Filter',
    status: 'Trạng thái',
    workType: 'Loại việc',
    room: 'Phòng',
    driff: 'Sai lệch',
    date: 'Ngày',
    type: 'Loại',
    showInactivedAccount: 'Hiển thị tài khoản không hoạt động'
  }
}
